// EDITORIAL 에서 사용하는 JS Events

// EDITORIAL > SEARCH 영역 이벤트 핸들러
// document.addEventListener('DOMContentLoaded', () => {
//   const customSearchResult = document.querySelector('.custom-search-result');

//   if (!customSearchResult) {
//     console.error("Custom search result element not found.");
//     return;
//   }

//   function updateOverflowStyle() {
//     if (customSearchResult.style.display === 'none') {
//       document.documentElement.style.overflow = ''; // display가 none이면 overflow 원래 상태로 복원
//     } else {
//       document.documentElement.style.overflow = 'hidden'; // display가 block이면 overflow hidden
//     }
//   }

//   // MutationObserver를 설정하여 스타일 변화를 감시합니다.
//   const observer = new MutationObserver(updateOverflowStyle);
//   observer.observe(customSearchResult, {
//     attributes: true,
//     attributeFilter: ['style'],
//   });
// });


// Swiper 초기화 함수 (선택자가 있을 경우에만 초기화)
/**
 * 
 * @param {string} selector init할 슬라이드
 * @param {string} paginationSelector 각 슬라이드 pagination
 * @returns 
 */
function initSwiper(selector, paginationSelector) {
  const element = document.querySelector(selector);
  if (element) {
    return new Swiper(selector, {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: paginationSelector,
        type: 'bullets',
      },
    });
  } else {
    // console
    console.warn(`Swiper element not found for selector: ${selector}`);
    return null;
  }
}

// Swiper init & destroy 관련
function destroySwiper(swiperInstance) {
  if (swiperInstance !== null) {
    swiperInstance.destroy(true, true);
  }
}

// 슬라이드 관련 클래스를 추가/제거
/**
 * 
 * @param {string} element swiper-container
 * @param {string} container swiper-wrapper
 * @param {string} sliders swiper-slide
 * @param {boolean} add True & False
 */
function toggleSwiperClasses(element, container, sliders, add) {
  if (element && container && sliders.length > 0) {
    if (add) {
      element.classList.add('swiper-container');
      container.classList.add('swiper-wrapper');
      sliders.forEach(slider => slider.classList.add('swiper-slide'));
    } else {
      element.classList.remove('swiper-container');
      container.classList.remove('swiper-wrapper');
      sliders.forEach(slider => slider.classList.remove('swiper-slide'));
    }
  }
}

// Swiper 관련 변수
let blogStoriesSwiper = null;
let blogTrendSwiper = null;
let blogBrandlabSwiper = null;
let blogPeopleSwiper = null;

// 창 크기에 따라 Swiper Init & Destroy
function blogHandleSwiper() {
  const isMobile = window.innerWidth <= 1023;

  // 각 카테고리에 대해 Swiper 설정 및 초기화
  const categories = [
    {
      selector: '.custom-default-blog-list.stories',
      paginationSelector: '.custom-default-blog-list.stories .swiper-pagination',
      swiperInstance: blogStoriesSwiper,
      setSwiper: swiper => (blogStoriesSwiper = swiper),
    },
    {
      selector: '.custom-default-blog-list.trend',
      paginationSelector: '.custom-default-blog-list.trend .swiper-pagination',
      swiperInstance: blogTrendSwiper,
      setSwiper: swiper => (blogTrendSwiper = swiper),
    },
    {
      selector: '.custom-default-blog-list.brand-lab',
      paginationSelector: '.custom-default-blog-list.brand-lab .swiper-pagination',
      swiperInstance: blogBrandlabSwiper,
      setSwiper: swiper => (blogBrandlabSwiper = swiper),
    },
    {
      selector: '.custom-default-blog-list.people',
      paginationSelector: '.custom-default-blog-list.people .swiper-pagination',
      swiperInstance: blogPeopleSwiper,
      setSwiper: swiper => (blogPeopleSwiper = swiper),
    },
  ];

  categories.forEach(({ selector, paginationSelector, swiperInstance, setSwiper }) => {
    const element = document.querySelector(selector);
    const container = element ? element.querySelector('ol') : null;
    const sliders = container ? container.querySelectorAll('li') : null;

    if (element && container && sliders.length > 0) {
      if (isMobile) {
        // Mobile에서 Init
        toggleSwiperClasses(element, container, sliders, true);
        if (!swiperInstance) {
          const swiper = initSwiper(selector, paginationSelector);
          setSwiper(swiper);
        }
      } else {
        // Mobile에서 Destroy
        toggleSwiperClasses(element, container, sliders, false);
        destroySwiper(swiperInstance);
        setSwiper(null);
      }
    } else {
      // Console
      console.warn(`Required elements not found for selector: ${selector}`);
    }
  });
}

// 창 크기 변경 감지
window.addEventListener('resize', blogHandleSwiper);

// 페이지 로드 시에도 초기화
blogHandleSwiper();
